import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import Header from '../../components/Header';
import { onGoBack } from '../../common/globals';
import { getSetProductContents } from '../../utils/utils';
import { getECSetDesc } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import SetContentNotLoaded from '../../components/Models/SetContentNotLoaded';
import withOnline from '../../common/withOnline';

class ExpressSetsContents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setsContents: {},
      setHeader: ''
    };
    this.setContentNotLoaded = null;
  }

  componentDidMount() {
    try {
      this.setContentNotLoaded = new window.bootstrap.Modal(
        window.$('#setContentNotLoadedModal')
      );
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getSetProducts = (id) => {
    try {
      const { notify, setLoader, online } = this.props;
      const productData = {};
      if (online) {
        setLoader(true);
        getSetProductContents({ set_name: id }).then((response) => {
          const { status, data } = response;
          if (status) {
            setLoader(false);
            data.map((item) => {
              if (!productData.hasOwnProperty(item.TrayName)) {
                productData[item.TrayName] = [];
              }
              productData[item.TrayName].push(item);
            });

            if (!Object.keys(productData).length > 0) {
              this.setContentNotLoaded.show();
            }

            this.setState({
              setsContents: productData
            });
          } else {
            setLoader(false);
            notify({ type: 'error', message: response.message });
          }
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetContentBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
      this.setContentNotLoaded.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getEcSetDesc = async () => {
    try {
      const { params: { id } } = this.props;
      const description = await getECSetDesc(id);
      this.setState({ setHeader: description });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { params, online, notify } = this.props;
      if (params.hasOwnProperty('id')) {
        if (online) {
          this._getSetProducts(params.id);
        } else {
          notify({ type: 'error', message: 'You must have an internet connection. Please check you connection and try again.', time: 3 });
        }
        await this._getEcSetDesc();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { goBack } = this.props;
    const { setsContents, setHeader } = this.state;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Set Contents"
          goBack={() => onGoBack(goBack)}
        />
        <section className="sets-section">
          <div className="container resizer-class">
            <div className="top-block pb-0">
              <h2 className="sets-title">{setHeader.ECSetDescription}</h2>
            </div>

            <div className="sets-list-blocks t-b-border-0 p-0">
              <div className="sets-block">
                {
                  Object.keys(setsContents).length > 0 ? Object.keys(setsContents)
                    .map((value, index) => (
                      <div className="sets-block" key={index}>
                        {
                          (value !== '')
                          && <h4><span>{(value === '' || value === null) ? '' : value}</span></h4>
                        }
                        {/* <h4><span>{value !== 'null' ? value : '(No Tray)' }</span></h4> */}
                        <ul className="list-unstyled">
                          {
                            setsContents[value].map((data, key) => (
                              <li className="pt-1 pb-1" key={key}>
                                <div className="contents-wrap">
                                  <div className="row gx-2">
                                    <div className="col">
                                      <p>{data.ProductNo}</p>
                                      <p>{data.ProductDescription}</p>
                                    </div>
                                    <div className="col-auto">
                                      <p>{`Qty: ${data.Qty}`}</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))
                          }
                        </ul>
                      </div>
                    )) : <p className="mt-5" style={{ textAlign: 'center' }}>Set contents are not loaded for this set</p>
                }
              </div>
            </div>

          </div>
        </section>
        <SetContentNotLoaded onSetContentBack={this._onSetContentBack} />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'SetInfoForm',
});

export default withOnline(
  withGoBack(
    withForm(
      withNotify(
        withLoader(
          ExpressSetsContents
        )
      )
    )
  )
);
